import CatalogTyreFilterStore from './tyre';
import CatalogWheelFilterStore from './wheel';
import {types as productTypes} from '../../../_constants/product/types';

export const getCatalogFilterStoreByProductType = (productType) => {
    if (productType === productTypes.WHEEL) {
        return CatalogWheelFilterStore;
    }
    if (productType === productTypes.TYRE_CAR || productType === productTypes.TYRE_MOTO) {
        return CatalogTyreFilterStore;
    }
};
